// Copyright (c) 2020 Comsearch, Inc., All rights reserved

const initSortData = data => data.sort((a, b) => {
  // sort first by year
  if (a.year > b.year) {
    return -1
  } else if (a.year < b.year) {
    return 1
  }
  // then sort by month
  if (a.month && b.month && a.month > b.month) {
    return -1
  } else if (a.month && b.month && a.month < b.month) {
    return 1
  }
  // then sort by count
  if (a.count && b.count && a.count > b.count) {
    return -1
  } else if (a.count && b.count && a.count < b.count) {
    return 1
  }
  return 0
})

export default initSortData
